import {helpers} from '@/ft-vue-core'
import {dataDefaults} from '../util/defaults'
import moment from 'moment'

const {deepClone} = helpers

export default {
  methods: {
    markAllNoShow () {
      for (let d of this.itemData.details) {
        d.noShow = true
      }
      this.$forceUpdate()
    },
    clearAllNoShow () {
      for (let d of this.itemData.details) {
        d.noShow = false
      }
      this.$forceUpdate()
    },
    getNameFromDetail (detail) {
      const guestType = this.guestTypeMap[detail.guestTypeId]
      if (!guestType) {
        return detail.memberId ? detail.name || 'Name Lookup Error' : 'Unknown'
      } else {
        return guestType.name || 'TBD'
      }
    },
    getReserveesForList (reservation) {
      const maxResult = 5
      const result = []
      if (!reservation.details) return result
      const details = reservation.details.filter(d => !d.isPlaceholder && (!reservation.cancelled && !d.cancelled || reservation.cancelled === d.cancelled))
      if (!details.length) return result
      if (!reservation.discreteCovers) {
        const suffix = details.length > 1 ? ' + ' + (details.length - 1) : ''
        result.push({
          name: this.getNameFromDetail(details[0]) + suffix
        })
        return result
      }
      var lastResult
      var name
      var d
      var i = 0
      for (let detail of details) {
        i++
        name = this.getNameFromDetail(detail)
        if (lastResult && name === lastResult.name) {
          lastResult.count++
        } else {
          if (i > maxResult - 1 && details.length > maxResult) {
            result.push({
              name: '+ ' + (details.length - (i - 1)) + ' more',
              count: 1
            })
            break
          }
          d = {
            name: name,
            count: 1
          }
          lastResult = d
          result.push(d)
        }
      }
      return result
    },
    getSelectedSeatingTime () {
      if (!this.forEvent) {
        // Meal period
        return this.seatingTimes.find(seatingTime => seatingTime.time === this.itemData.time &&
          this.getMealPeriod(seatingTime.mealPeriodId).locationId === this.itemData.locationId) || null
      } else {
        // Event
        return this.seatingTimes.find(seatingTime => seatingTime.time === this.itemData.time &&
          seatingTime.locationId === this.itemData.locationId) || null
      }
    },
    setSelectedSeatingTime (seatingTime) {
      const thisItemData = this.itemData
      if (!seatingTime) {
        this.noTimeSelected = true
        return
      }
      this.noTimeSelected = false
      if (!this.forEvent) {
        // Meal period
        thisItemData.locationId = this.getMealPeriod(seatingTime.mealPeriodId).locationId
      } else {
        // Event
        thisItemData.locationId = seatingTime.locationId
      }
      // Set time
      thisItemData.time = seatingTime.time
      // set discreteCovers
      if (seatingTime.discreteCovers !== thisItemData.discreteCovers && (
        this.itemData.eventId !== (seatingTime.eventId || null) ||
          this.itemData.locationId !== seatingTime.locationId ||
          this.itemData.time !== seatingTime.time ||
          this.itemData.date !== seatingTime.date ||
          !this.hasDiscreteDetailValues
      )) {
        this.itemData.discreteCovers = seatingTime.discreteCovers
      }
    },
    convertToWaitlistAndSave () {
      this.convertToWaitlist()
      this.saveItem()
    },
    convertToWaitlist () {
      this.itemData.waitlist = true
    },
    convertWaitlistToReservationAndSave () {
      this.convertWaitlistToReservation()
      this.saveItem()
    },
    convertWaitlistToReservation () {
      this.itemData.waitlist = false
    },
    walkInDateSelect () {
      if (this.isNewItem && this.selectedReservationType.code === 'WALK_IN') {
        this.itemData.date = this.$ftAPI().clubMoment().format('YYYY-MM-DD')
      }
    },
    walkInTimeSelect () {
      const itemData = this.itemData
      const selectedTime = this.selectedSeatingTime
      if (this.isNewItem &&
        this.selectedReservationType.code === 'WALK_IN' &&
        this.availSeatingTimes.length &&
        (!selectedTime || selectedTime.disabled)) {
        const lastLocationId = this.itemData.locationId || parseInt(localStorage.getItem('lastWalkInLocationId') || 0, 10)
        const clubMoment = this.$ftAPI().clubMoment()
        var nextSeating = this.availSeatingTimes.find(seating => {
          // Try to get next available seating time, filtering by last used location id, if any
          let seatingMoment = moment(seating.date + ' ' + seating.time)
          return seatingMoment.isAfter(clubMoment) && (!lastLocationId || lastLocationId === seating.locationId)
        })
        if (!nextSeating && lastLocationId) {
          // couldn't find seating for last location.  Just grab next available seating time.
          nextSeating = this.availSeatingTimes.find(seating => {
            let seatingMoment = moment(seating.date + ' ' + seating.time)
            return seatingMoment.isAfter(clubMoment)
          })
        }
        if (nextSeating) {
          if (itemData.time !== nextSeating.time) {
            itemData.time = nextSeating.time
          }
          if (itemData.date !== nextSeating.date) {
            itemData.date = nextSeating.date
          }
          if (itemData.locationId !== nextSeating.locationId) {
            itemData.locationId = nextSeating.locationId
          }
          if (!nextSeating.eventId) nextSeating.eventId = null
          if (itemData.eventId !== nextSeating.eventId) {
            itemData.eventId = nextSeating.eventId
          }
        }
      }
    },
    modifyItemDataBeforeSave (data) {
      if (this.isNewItem) {
        data.walkIn = this.selectedReservationType.code === 'WALK_IN'
      }
    },
    formatEventDateTime (event) {
      if (!event) return ''
      const intoNextDay = event.startTime > event.endTime
      const startDate = moment(event.date + ' ' + event.startTime)
      const endDate = moment(event.date + ' ' + event.endTime).add(intoNextDay ? 1 : 0, 'days')
      const result = []
      result.push(startDate.format('ddd, MMM Do YYYY h:mm A'))
      result.push('to')
      if (intoNextDay) {
        result.push(endDate.format('ddd, MMM Do h:mm A'))
      } else {
        result.push(endDate.format('h:mm A'))
      }
      return result.join(' ')
    },
    dateHasBlocker (date) {
      return !!this.blockedMealPeriodDates[date] || !!this.partialMealPeriodDates[date] || !!this.eventMealPeriodDates[date]
    },
    dateColor (date) {
      return this.blockedMealPeriodDates[date] ? 'error' : this.partialMealPeriodDates[date] ? 'warning' : this.eventMealPeriodDates[date] ? 'info' : 'warning'
    },
    allowedPickerDates (date) {
      const selectableMealPeriodDates = this.selectableMealPeriodDates
      return !!(selectableMealPeriodDates[date] && selectableMealPeriodDates[date] && selectableMealPeriodDates[date][0])
    },
    filterDiscreteCovers (items, search, filter, headers) {
      console.warn('filterDiscreteCovers', items, search, filter, headers)
      if (this.itemData.discreteCovers) return items
      return items.filter((d, i) => i < 1)
    },
    itemRowClass (item, index) {
      const classes = {
        'ft-cancelled-item': !!item.cancelled,
        'warning ft-darken-hover': !!item.issues,
        'ft-member-orig': !!item.origMemberId
      }
      return classes
    },
    promptDiscreteCovers () {
      const val = !this.itemData.discreteCovers
      if (!this.discreteCoversMatchSeating) {
        // the new value will correct the mis-matched state.  Just allow it.
        this.itemData.discreteCovers = val
      } else {
        // New value will create a mis-matched state.  Make sure they want to do this.
        var message = 'The selected ' + this.eventOrLocation +
        ' is set to ask details for ' + (this.itemData.discreteCovers ? 'each reservee' : 'only the first reservee') +
        '.  Are you sure you want this reservation to be different?'
        this.$vPrompt({
          width: 320,
          title: this.toggleDiscreteCoversMenuTitle,
          titleIcon: 'mdi-alert',
          titleIconColor: 'warning',
          text: message,
          cancelText: 'No',
          cancelAction: true,
          confirmText: 'Yes',
          confirmAction: () => {
            this.itemData.discreteCovers = val
          }
        })
      }
    },
    setCheckNumbers (max) {
      this.itemData.details.forEach(d => {
        if (max === 1) {
          d.checkNumber = 1
        } else if (d.checkNumber > max) {
          d.checkNumber = max
        }
      })
    },
    memberSelectFocus (memberSelect) {
      this.lastActiveInput = memberSelect
    },
    hideLastActive () {
      if (this.lastActiveInput && this.lastActiveInput.vselect) {
        this.lastActiveInput.vselect.blur()
      }
    },
    addMultiplePrompt () {
      this.addMultipleCount = null
      this.showAddMultipleDialog = true
      const addMultiInput = this.$refs['addMultipleInput']
      if (addMultiInput) {
        setTimeout(() => {addMultiInput.focus()}, 0)
      }
    },
    addMultiple () {
      this.showAddMultipleDialog = false
      if (this.addMultipleCount > 0) {
        const newPartySize = this.partySize + parseInt(this.addMultipleCount, 10)
        this.partySize = newPartySize
      }
    },
    getMealPeriod (id) {
      return this.mealPeriods.find(mealPeriod => mealPeriod.id === id) || {}
    },
    isMemberSelected (memberId) {
      return !!this.selectedMembers[memberId]
    },
    nextOpenDetail (start) {
      var result = null
      var result2 = null
      this.itemData.details.forEach((d, i) => {
        if (result == null && !d.name && !d.memberId && !d.guestId && (!d.id || d.isPlaceholder || d.guestTypeId && d.guestTypeId === this.guestTbdId)) result = i
        if (result2 == null && i > start && !d.name && !d.memberId && !d.guestId && (!d.id || d.isPlaceholder || d.guestTypeId && d.guestTypeId === this.guestTbdId)) result2 = i
      })
      if (result != null || result2 != null) {
        const i = Math.max(result, result2)
        return i
      } else {
        return null
      }
    },
    typeSelected (props) {
      const item = props.item
      if (item.guestTypeId === null) {
        // is member
        item.guestId = null
        item.guestHostId = null
        item.name = null
      } else {
        // is guest or tbd
        this.selectedMembers[item.memberId] = false
        item.memberId = null
        item.name = null
        const guestType = this.modGuestTypes.find(g => g.id === item.guestTypeId)
        if (guestType && guestType.isTbd) {
          item.guestId = null
          item.name = null
          item.guestHostId = null
        }
      }
    },
    onMemberPrefsEdit (member) {
      console.log('Properties Edit:', member)
      const rcpts = []
      if (member.emailOpt && member.email) rcpts.push(member.email)
      if (member.emailOpt2 && member.email2) rcpts.push(member.email2)
      this.itemData.details
        .filter(d => d.memberId === member.id)
        .forEach(d => {
          d.notificationRcpts = rcpts
        })
    },
    memberSelected (props, member) {
      if (!member) {
        props.item.memberId = null
        props.item.notificationRcpts = []
        return
      }
      const rcpts = []
      if (member.emailOpt && member.email) rcpts.push(member.email)
      if (member.emailOpt2 && member.email2) rcpts.push(member.email2)
      props.item.memberId = member.id
      props.item.name = member.nameFull
      props.item.memberNumber = member.memNum
      props.item.username = member.username
      props.item.notificationRcpts = rcpts
      // if (!props.item.memberId) return
      // const availInList = (this.lastMemberFilter.result || []).find(m => !this.selectedMembers[m.id])
      // if (!availInList) return
      const nextOpen = this.nextOpenDetail(props.row)
      if (nextOpen) {
        const prevGuestTypeId = this.itemData.details[nextOpen].guestTypeId
        this.itemData.details[nextOpen].guestTypeId = null
        this.$nextTick(() => {
          // In timeout to allow possible change from TBD to Member to complete
          const current = this.$refs['reserveeSelect_' + props.row]
          var currentItem
          if (current) {
            currentItem = current.currentSelection()
            current.blur()
          }
          const selector = this.$refs['reserveeSelect_' + nextOpen]
          if (selector) {
            selector.setFilter(this.lastMemberFilter, currentItem, () => {
              this.itemData.details[nextOpen].guestTypeId = prevGuestTypeId
            })
          } else {
            console.warn('Can\'t find member selector:', nextOpen, this.$refs)
          }
        })
      }
    },
    guestSelected (props) {
      const lastGuest = this.itemData.details[props.row]
      const nextOpen = this.nextOpenDetail(props.row)
      if (nextOpen) {
        this.itemData.details[nextOpen].guestTypeId = lastGuest.guestTypeId
        this.$nextTick(() => {
          const selector = this.$refs['reserveeSelect_' + nextOpen]
          if (selector) {
            selector.focus()
          }
        })
      }
      props.item.notificationRcpts = []
    },
    addDetailToCancelled (item) {
      if (item.isPlaceholder || !item.id) return // New detail or placeholder.  Just remove it.
      this.itemData.cancelledDetails.push(item)
      this.clearPathErrors(this.jsonPath, 'cancelledDetails')
      this.showCancelledReservees = true // Show cancelled reservees after you cancel them
    },
    addDetail (item) {
      this.itemData.details.push(item)
      this.clearPathErrors(this.jsonPath, 'details')
    },
    moveDetailToCancelled (rowIndex, deleteAction) {
      this.addDetailToCancelled(this.itemData.details[rowIndex])
      deleteAction(rowIndex, this.deleteItem)
    },
    moveCancelledToDetail (rowIndex, deleteAction) {
      this.addDetail(this.itemData.cancelledDetails[rowIndex])
      deleteAction(rowIndex, this.deleteItem)
    },
    getDateTimeDisplay (dateTime) {
      if (!dateTime) return '—'

      const m = moment(dateTime)
      if (!m.isValid()) return '—'

      return m.format('YYYY-MM-DD h:mm A')
    },
    getTimeDisplay (time) {
      return moment(time, 'HH:mm:ss').format('h:mm A')
    },
    getAuditTrailGuestType (item) {
      if (item.recordPost) {
        return (this.guestTypeMap[item.recordPost.guestTypeId] || {}).name || (item.recordPost.isPlaceholder ? 'Placeholder' : null)
      } else if (item.recordPre) {
        return (this.guestTypeMap[item.recordPre.guestTypeId] || {}).name || (item.recordPre.isPlaceholder ? 'Placeholder' : null)
      }
      return null
    },
    toggleCancelledReservee () {
      this.showCancelledReservees = !this.showCancelledReservees
      console.log('showCancelledReservees', this.showCancelledReservees)
    },
    deleteReserveeConfirmText (item) {
      return !item.id || item.isPlaceholder ? 'Delete' : 'Cancel'
    },
    cancelReservationPrompt () {
      this.showCancelReservationDialog = true
    },
    abortReservationCancellation () {
      this.itemData.cancelled = null
      this.showCancelReservationDialog = false
    },
    cancelReservation () {
      this.itemData.cancelled = moment().format('YYYY-MM-DD HH:mm:ss') // A valid date will trigger a cancellation. API will override with proper date/time
      // Save the item
      this.saveItem((ftresponse) => {
        // If we fail saving...
        this.itemData.cancelled = null
      })
    },
    unCancelReservationPrompt () {
      this.$vPrompt({
        title: 'Un-Cancel Reservation',
        titleIcon: 'mdi-backup-restore',
        titleIconColor: 'primary',
        text: 'Are you sure you want to un-cancel this reservation?',
        confirmText: 'Yes',
        confirmAction: () => {
          this.showCancelledReservees = true
          const unCancelledDetails = this.itemData.cancelledDetails.filter(cd => cd.cancelled === this.itemData.cancelled)
          for (let unCancelledDetail of unCancelledDetails) {
            this.addDetail(unCancelledDetail)
          }
          for (let i = this.itemData.cancelledDetails.length - 1; i >= 0; i--) {
            if (this.itemData.cancelledDetails[i].cancelled === this.itemData.cancelled) {
              console.log('removing', this.itemData.cancelledDetails[i])
              this.itemData.cancelledDetails.splice(i, 1)
              this.clearPathErrors(this.jsonPath, 'cancelledDetails')
            }
          }
          this.itemData.cancelled = null
        },
        cancelText: 'No',
        disableConfirm: this.isSaveDisabled,
        cancelAction: true
      })
    },
    resetLocalValues (keepItemData) {
      if (keepItemData) return
      // Reset defaults
      const clonedDefaults = deepClone(dataDefaults)
      for (let key in clonedDefaults) {
        this[key] = clonedDefaults[key]
      }
    },
    setDefaultNotificationMode (item) {
      this.reservationNotificationMode = item.eventId ? this.$ftCS.DINING_DEFAULT_EVENT_RESERVATION_NOTIFICATION_MODE : this.$ftCS.DINING_DEFAULT_RESERVATION_NOTIFICATION_MODE
    },
    showTableNumberUsage () {
      this.showTableNumberUsageDialog = true
      this.loadTableNumberUsage()
    },
    tableNumberUsageClass (tableNumber) {
      const tableNumbers = this.tableNumberParsed
      const sameTable = tableNumbers.reduce((a, t) => {return a || !tableNumber.localeCompare(t, 'en', {sensitivity: 'base'})}, false)
      return {
        'ft-small-chip': true,
        'grey': !sameTable,
        'yellow': sameTable,
        'lighten-2': true
      }
    },
    splitTableNumbers (tables) {
      if (!tables) return []
      return tables.split(/\s*,\s*/).filter(t => !!t.trim().length)
    },
    getEditForm () {
      console.log('editForm', this.$refs.editForm)
      return this.$refs.editForm.$refs.editForm.$el
    },
    periodCountsByPartySize (seating, partySize) {
      partySize = partySize || 1
      // Return cache if we have any
      if (!seating._pcLookup) seating._pcLookup = {}
      if (seating._pcLookup[partySize]) return seating._pcLookup[partySize]
      const periodCounts = seating.periodCounts || {}
      let ic = 1
      for (let i in periodCounts) {
        let ii = parseInt(i, 10)
        if (ii > partySize) break
        if (ii > ic) {
          ic = ii
        }
      }
      const result = periodCounts[ic] || {}
      seating._pcLookup[partySize] = result
      return result
    },

  }
}
